import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { postVerifySms, VerifySmsRequest, VerifySmsResponse } from "../index";

/**
 * SMS 인증번호 확인 Hook
 */
export const usePostVerifySms = (
  options?: UseMutationOptions<VerifySmsResponse, Error, VerifySmsRequest>
) => {
  return useMutation<VerifySmsResponse, Error, VerifySmsRequest>({
    mutationFn: postVerifySms,
    ...options,
  });
};

